/*global qq */
qq.version = "5.12.0";
